// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"31":"748932e410d6c3d09cbd","50":"43fab802c7e4de90d167","740":"fd1bb69f5f88bc92e8b8"}[chunkId] + ".min.js";
};